// @flow
import * as React from 'react';
import ImagePicker from 'components/ImagePicker';
import { wrapPromise } from 'utils/functional';
import ShowConfirmationModal from 'containers/ShowConfirmationModal';
import Field from './Field';

const ImagePickerField = ({
  name,
  label,
  description,
  previewWidth,
  previewHeight,
  format,
  message,
  centerButton,
  overlayButton,
  disableCrop,
  confirmModal,
  onChange,
  'data-qa-id': qaId,
  recommendedDimensions,
  ...props
}: {
  name: string,
  label?: string,
  description?: string,
  previewWidth?: number,
  previewHeight?: number,
  format?: 'logo' | 'banner',
  message?: string,
  centerButton?: boolean,
  overlayButton?: boolean,
  disableCrop?: boolean,
  confirmModal?: Object,
  'data-qa-id'?: string,
  onChange?: Function,
  recommendedDimensions?: { width: number, height: number }
}) => {
  const Picker = pickerProps => (
    <ImagePicker
      name={name}
      previewWidth={previewWidth}
      previewHeight={previewHeight}
      format={format}
      message={message}
      centerButton={centerButton}
      overlayButton={overlayButton}
      disableCrop={disableCrop}
      {...pickerProps}
      {...props}
    />
  );
  return (
    <Field
      {...props}
      name={name}
      label={label}
      description={description}
      renderInput={({ value, qaId: autoQaId, updateValue }) =>
        confirmModal ? (
          <ShowConfirmationModal
            {...confirmModal}
            onConfirm={wrapPromise(() => {
              if (onChange) {
                onChange(null);
              } else {
                updateValue(null);
              }
            })}
            render={({ showModal: showConfirmationModal }) => (
              <Picker
                showConfirmationModal={showConfirmationModal}
                image={value}
                data-qa-id={qaId || autoQaId}
                onChange={onChange || updateValue}
                recommendedDimensions={recommendedDimensions}
                label={label}
              />
            )}
          />
        ) : (
          <Picker
            image={value}
            data-qa-id={qaId || autoQaId}
            onChange={onChange || updateValue}
            recommendedDimensions={recommendedDimensions}
            label={label}
          />
        )
      }
    />
  );
};

export default ImagePickerField;
